export let originData = [];

export function setData(data) {
    originData = data;
}